import React from 'react';

import {MIN_FRAGMENT_BINS_COUNT, getMaxFragmentBinCount} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericButtonInput from 'ui-library/inputs/NumericButtonInput';

/**
 * An input to set the number of bins in the assembly.
 *
 * @param {boolean} disabled Whether to disable the input.
 * @param {(number | null)} value The current number of bins for the input.
 * @param {function} onChangeValue Callback to update the number of bins.
 * @constructor
 */
export function BinsCount({
  disabled,
  value,
  onChangeValue,
}: {
  disabled: boolean;
  value: number | null;
  onChangeValue: ({isValid, value}: {isValid: boolean; value: number | null}) => void;
}): JSX.Element {
  return (
    <FormGroup>
      <FieldLabel label="Number of fragment bins" htmlFor="numFragmentBins" isRequired={true} />
      <NumericButtonInput
        value={value}
        onChangeValue={onChangeValue}
        disabled={disabled}
        required={true}
        minValue={MIN_FRAGMENT_BINS_COUNT}
        maxValue={getMaxFragmentBinCount()}
        defaultValue={MIN_FRAGMENT_BINS_COUNT}
        dataTestAttrs={{component: 'BulkAssemblySetupModal', element: 'numBinsInput'}}
      />
    </FormGroup>
  );
}
